import { getCookie, removeCookie } from '@shared/lib';

/**
 * TRAD-3861(web) ↔ TRAD-3860(backend) — 리프레시 토큰이 서버 HttpOnly 쿠키(`xtRefreshToken`, web 코드엔 이름이 등장하지 않는다)로
 * 옮겨 간 뒤에도, **이행기**에는 옛 번들이 JS 로 심어 둔 쿠키 `refreshToken`(30일)이 브라우저에 남아 있다.
 * 계약(docs-ops/2026-10-29-TRAD-3860-cookie-contract.md §2 1단계): 새 web 이 그 쿠키를 보면 **재발급 body 에 1회 동봉**(서버는
 * 쿠키 우선 → body 폴백) → 응답 Set-Cookie 로 전환 → JS 쿠키를 지운다. 그 뒤로는 body 키 0.
 *
 * 🔴 옛 쿠키 이름 리터럴은 **이 파일에만** 둔다 — W6 가드(`legacy-refresh-cookie-guard-3861.test.ts`)가 src 의 다른 파일에서
 *    `'refreshToken'` 리터럴이 다시 생기면 실패시킨다(쿠키 쓰기·읽기 경로가 되살아나는 것을 막는다). 값은 로그·테스트 출력에 찍지 않는다.
 */
export const LEGACY_REFRESH_COOKIE = 'refreshToken';

/** 옛 JS 쿠키의 키(있으면) — 재발급 body 에 1회 동봉할 값. 없으면 undefined. */
export const readLegacyRefreshTokenKey = (): string | undefined => getCookie(LEGACY_REFRESH_COOKIE) || undefined;

/** 옛 JS 쿠키 제거 — 재발급 성공(서버 쿠키로 전환) · 세션 끝 · 로그아웃 때. 없어도 안전. */
export const clearLegacyRefreshToken = (): void => removeCookie(LEGACY_REFRESH_COOKIE);
